import React, {useState, useEffect} from 'react';
import {
    Container,
    FormControlLabel,
    Grid,
    Radio, RadioGroup,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
	Box
} from "@mui/material";
import {makeStyles} from '@mui/styles';
import Typography from "@mui/material/Typography";
import {isDealerSite} from "../../../utils/utils";
import NautilusTextInput from "../../Common/NautilusTextInput";
import Icon from "@mui/material/Icon";

const useStyles = makeStyles({
    table: {
        minWidth: 400,
    },
    cells: {
        fontSize: '1.4rem',
        verticalAlign: 'middle !important',
    },
});

function Payment({paySchedule, setPayThisMuch, payThisMuch, allowCustomPay, flywire}) {
    const classes = useStyles();
    const [customAmount, setCustomAmount] = useState(false);
    const [customValue, setCustomValue] = useState('');

    useEffect(() => {
        handleCustomAmount(customValue);
    }, [customValue]);


    const handlerPayThis = (event) => {
        const index = event.target.value;
        if (index === 'other') {
            setPayThisMuch(0.0);
            return setCustomAmount(true);
        }
        const amount = paySchedule[index]['paymentdue'];
        const val = amount.replace(/[^0-9.-]+/g, "");
        if (customAmount) setCustomAmount(false);
        setPayThisMuch(parseFloat(val));
    };

    const handleCustomAmount = (value) => {
        if (!value) return setPayThisMuch(0.0);

        let regex = /^\d+(\.\d{1,2})?$/;
        if (!value.match(regex)) return;

        setPayThisMuch(parseFloat(value));
    };

    return (
        <Container maxWidth="lg">
            <Grid container direction="column" spacing={3} alignItems={"center"} justify={"center"} sx={{padding: 0, margin: 0, width: '100%'}}>
				{flywire ?
					<Grid item xs sx={{width: '100%', marginLeft: 0, padding: '30px 0px 20px 0px !important'}}>
						<Typography variant="h5" component="h5" sx={{width: '100%', fontSize: '18px'}}>
							Pay in your local currency by credit card or bank transfer and save on exchange rate or bank fees
						</Typography>
					</Grid>
					:
					<Grid item xs sx={{width: '100%', marginLeft: 0, padding: '30px 0px 20px 0px !important'}}>
						<Typography variant="h5" component="h5" align="left">
							Icarus Aviation dba Nautilus Explorer - Nautilus Liveaboards, Nautilus Dive Adventures, a
							Canadian company
							<br/>
						</Typography>
						<Typography variant="body1" align="left">
							Please note that while this transaction will be processed in US dollars via our U.S. Bank
							account, some clients' bank/credit card companies have charged a "foreign transaction fee"
							because we are a Canadian company. Review with your credit card company or if you prefer, we
							would be pleased to accept your personal cheque as long as it is received by our office at least
							60 days prior to your departure date.<br/><br/>
							All transactions are made in US Dollars. We accept Visa, Mastercard, and American Express. <br/>
							{(isDealerSite() || !allowCustomPay) && <span>
								<strong>NOTE:</strong> Dealers can only use credit cards for initial payments. All subsequent
								payments must be made by Wire Transfer or Cheque.
							</span>}
						</Typography>
					</Grid>
				}
                <Grid item xs>
                    <div className="center">
                        <img src={`${window['appBasename']}/images/payment-methods.jpg`}
                             alt="Mastercard, Visa, American Express"
                             style={{height: 50, width: 233, margin: '1.5rem auto'}}/>
                    </div>
                </Grid>
                {paySchedule.length > 0 && paySchedule.filter((pay) => pay.payable === true).length === 0 ?
                    <Typography align={'center'} variant={'h4'}>
                        <Icon
                            sx={{fontSize: '140px', marginTop: '20px', marginBottom: '20px'}}>warning_amber</Icon><br/>
                        There are not available payments for this booking. Please contact to our office, we will help
                        you to pay it.
                    </Typography> :
                    <Grid item xs>
                        <RadioGroup aria-label="pay-options" name={'payThisMuch'} onChange={handlerPayThis}>
                            <Table className={classes.table} aria-label="simple table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell className={classes.cells} align="center">Payment</TableCell>
                                        <TableCell className={classes.cells} align="center">Amount</TableCell>
                                        <TableCell/>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {paySchedule.length > 0 && paySchedule.filter((pay) => pay.payable === true).map((pay, index) => (
                                        <TableRow key={index}>
                                            <TableCell className={classes.cells}
                                                       align="center"><strong>{pay['paymenttitle']}</strong></TableCell>
                                            <TableCell className={classes.cells} style={{whiteSpace: 'nowrap'}}
                                                       align="center">$ {pay['paymentdue']}</TableCell>
                                            <TableCell className={classes.cells} align="center">
                                                <FormControlLabel
                                                    className={'cleanCheckbox'}
                                                    value={index}
                                                    control={<Radio color="primary"/>}
                                                    label={`Pay this`}/>
                                            </TableCell>
                                        </TableRow>))}
                                    {allowCustomPay && paySchedule.length > 0 && (
                                        <TableRow>
                                            <TableCell className={classes.cells}
                                                       align="center"><strong>Custom Amount</strong></TableCell>
                                            <TableCell className={classes.cells} style={{whiteSpace: 'nowrap'}}
                                                       align="center">{customAmount && payThisMuch > 0 ? `$ ${payThisMuch.formatMoney(2)}` : '-'}</TableCell>
                                            <TableCell className={classes.cells} align="center">
                                                <FormControlLabel
                                                    className={'cleanCheckbox'}
                                                    value={'other'}
                                                    control={<Radio color="primary"/>}
                                                    label={`Pay this`}/>
                                            </TableCell>
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>
                        </RadioGroup>
                        {customAmount && <NautilusTextInput
                            style={{marginTop: '20px'}}
                            label="Amount"
                            name="other"
                            value={customValue}
                            onChange={(e) => setCustomValue(e.target.value)}
                            variant="outlined"
                            fullWidth
                        />}
                    </Grid>
                }
            </Grid>
        </Container>
    );
}

export default Payment;